import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { IAttachment } from '../../interfaces/IAttachment';

@Component({
  selector: 'ngx-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AttachmentsComponent {
  @Input() attachments: IAttachment[] = [];
  @Output() remove = new EventEmitter<number>();

  removeAttachment(index: number) {
    this.remove.emit(index);
  }
}
